import React from "react";
import FileChonky from "../components/chonky/index";

export default function FileManager() {
  const showWindow = () => {
    console.log("showWindow");
  };

  return (
    <>
      <br />
      <FileChonky showWindow={showWindow} />
    </>
  );
}
